<template>
  <b-modal
    id="delete-group-modal"
    title="Delete Group"
    hide-footer
  >
    <h4 class="mb-2">
      Are you sure you want to delete {{ name }}?
    </h4>
    <b-button
      variant="danger"
      block
      :disabled="deletingGroup"
      @click="deleteGroup"
    >
      <b-spinner
        v-if="deletingGroup"
        small
      />
      <span v-else>Delete Group</span>
    </b-button>
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const name = computed(() => props.group?.name?.en || '')

    const deletingGroup = ref(false)
    const deleteGroup = async () => {
      try {
        deletingGroup.value = true
        await ctx.root.$store.dispatch('business/deleteGroup', {
          groupId: props.group.id,
          payload: {
            businessId,
          },
        })
        ctx.root.$bvModal.hide('delete-group-modal')
        ctx.emit('group-deleted')
      } finally {
        deletingGroup.value = false
      }
    }
    return {
      name,
      deleteGroup,
      deletingGroup,
    }
  },
}
</script>

    <style>

    </style>
